import {
  ChartBarIcon,
  BellIcon,
  Cog6ToothIcon,
  EnvelopeIcon,
} from "@heroicons/react/24/outline";
import { NavigationItem } from "./types";

const navigation: NavigationItem[] = [
  {
    name: "Call Scoring",
    href: "/transcripts/call-scoring",
    icon: ChartBarIcon,
    current: false,
    internalName: "call-scoring",
    permissions: [],
    roles: ["ROLE_SUPER_ADMIN"],
  },
  {
    name: "Notification Recipients",
    href: "/transcripts/notification-recipients",
    icon: BellIcon,
    current: false,
    internalName: "notification-recipients",
    permissions: [],
    roles: ["ROLE_SUPER_ADMIN"],
  },
  {
    name: "Scoring Settings",
    href: "/transcripts/scoring-settings",
    icon: Cog6ToothIcon,
    current: false,
    internalName: "scoring-settings",
    permissions: [],
    roles: ["ROLE_SUPER_ADMIN"],
  },
  {
    name: "Email Template",
    href: "/transcripts/email-template",
    icon: EnvelopeIcon,
    current: false,
    internalName: "email-template",
    permissions: [],
    roles: ["ROLE_SUPER_ADMIN"],
  },
];

export default { navigation };
